var _circle, _circle2, _circle3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaypush(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3678,
    cy: 23.6322,
    r: 22.8678,
    fill: "url(#paint0_linear_1_3326)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3678,
    cy: 23.6322,
    r: 22.8678,
    fill: "url(#paint1_angular_1_3326)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23.3678,
    cy: 23.6322,
    r: 22.8678,
    fill: "url(#paint2_linear_1_3326)",
    fillOpacity: 0.6,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3678,
    cy: 23.6322,
    r: 22.8678,
    stroke: "#757575"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 5,
    height: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 5,
    height: 21,
    fill: "url(#paint3_radial_1_3326)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 5,
    height: 21,
    fill: "url(#paint4_linear_1_3326)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 5,
    height: 21,
    stroke: "url(#paint5_linear_1_3326)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 5,
    height: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 5,
    height: 21,
    fill: "url(#paint6_radial_1_3326)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 5,
    height: 21,
    fill: "url(#paint7_linear_1_3326)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 5,
    height: 21,
    stroke: "url(#paint8_linear_1_3326)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3326",
    x: 15.75,
    y: 10.75,
    width: 20.5,
    height: 27.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3326",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3326",
    x1: 0,
    y1: 0.264404,
    x2: 46.7357,
    y2: 0.264404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C40E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A44B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_1_3326",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.735 -30) rotate(142.505) scale(126.502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471354,
    stopColor: "white",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3326",
    x1: 23.7354,
    y1: -6,
    x2: 30.7354,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDFDFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_3326",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5789 23.1098) rotate(105.304) scale(16.1208 6.69587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_3326",
    x1: 18.8183,
    y1: 10.5702,
    x2: 32.8158,
    y2: 32.9039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_3326",
    x1: 19.5519,
    y1: 34.1447,
    x2: 9.71406,
    y2: 28.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_3326",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5789 23.1098) rotate(105.304) scale(16.1208 6.69587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_3326",
    x1: 27.8183,
    y1: 10.5702,
    x2: 41.8158,
    y2: 32.9039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_3326",
    x1: 28.5519,
    y1: 34.1447,
    x2: 18.7141,
    y2: 28.3892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#959595"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaypush);
export default __webpack_public_path__ + "static/media/playpush.f2c7d0c80774d0f9069fe92eb88826e3.svg";
export { ForwardRef as ReactComponent };